// import { CirclePlus, X } from "lucide-react";
// import { useEffect, useState } from "react";
// import api from "../../api/axios";
// import Swal from "sweetalert2";

// export default function GraceWeekoffSettings() {
//   const weekDays = [
//     { value: "monday", label: "Monday" },
//     { value: "tuesday", label: "Tuesday" },
//     { value: "wednesday", label: "Wednesday" },
//     { value: "thursday", label: "Thursday" },
//     { value: "friday", label: "Friday" },
//     { value: "saturday", label: "Saturday" },
//     { value: "sunday", label: "Sunday" },
//   ];

//   const ordinal = ["1st", "2nd", "3rd", "4th", "5th"];

//   const [graceMinutes, setGraceMinutes] = useState("");
//   const [primaryWeekoff, setPrimaryWeekoff] = useState("monday");
//   const [enableSecondary, setEnableSecondary] = useState(false);
//   const [secondaryWeekoff, setSecondaryWeekoff] = useState("monday");

//   const [autoAuditEnabled, setAutoAuditEnabled] = useState(false);
//   const [auditTimes, setAuditTimes] = useState([""]);
//   const [secondaryWeekoffOccurrence, setSecondaryWeekoffOccurrence] = useState(
//     []
//   );

//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const loadSettings = async () => {
//       try {
//         const res = await api.get("/hrms/settings");
//         const data = res.data.data;

//         if (data) {
//           setGraceMinutes(data.grace_minutes || "");
//           setPrimaryWeekoff(data.primary_weekoff || "monday");
//           setEnableSecondary(data.enable_secondary_weekoff || false);
//           setSecondaryWeekoff(data.secondary_weekoff || "monday");
//           setAutoAuditEnabled(data.auto_audit_enabled || false);
//           setAuditTimes(data.audit_times?.length ? data.audit_times : [""]);
//         }
//       } catch (err) {
//         Swal.fire("Error", "Failed to load settings", "error");
//       }
//       setLoading(false);
//     };

//     loadSettings();
//   }, []);

//   const handleOccurrenceChange = (value) => {
//     setSecondaryWeekoffOccurrence((prev) => {
//       if (prev.includes(value)) {
//         return prev.filter((item) => item !== value);
//       } else {
//         return [...prev, value];
//       }
//     });
//   };

//   const handleAddTime = () => setAuditTimes([...auditTimes, ""]);

//   const handleTimeChange = (i, val) => {
//     const updated = [...auditTimes];
//     updated[i] = val;
//     setAuditTimes(updated);
//   };

//   const handleDeleteTime = (i) =>
//     setAuditTimes(auditTimes.filter((_, index) => index !== i));

//   const saveSettings = async () => {
//     try {
//       await api.put("/hrms/settings", {
//         grace_minutes: graceMinutes,
//         primary_weekoff: primaryWeekoff,
//         enable_secondary_weekoff: enableSecondary,
//         secondary_weekoff: enableSecondary ? secondaryWeekoff : null,
//         secondary_weekoff_occurrence: secondaryWeekoffOccurrence.length > 0 ? secondaryWeekoffOccurrence : [],
//         auto_audit_enabled: autoAuditEnabled,
//         audit_times: autoAuditEnabled ? auditTimes : [],
//       });

//       Swal.fire("Success", "Settings saved successfully", "success");
//     } catch (err) {
//       Swal.fire("Error", "Unable to save settings", "error");
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <h5>Loading Settings...</h5>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="container mt-4">
//         <div className="d-flex flex-column">
//           <h5 className="fs-5 fw-semibold m-0">
//             Grace Time & WeekOff Settings
//           </h5>
//           <span className="text-muted fs-6">
//             Set the grace period for late entries, globally and week-off
//             settings
//           </span>
//         </div>

//         <div className="row align-items-end g-4 mb-4 mt-1">
//           <div className="col-md-4">
//             <label className="form-label fw-semibold">Grace Minutes</label>
//             <input
//               type="number"
//               className="form-control"
//               placeholder="e.g. 10"
//               value={graceMinutes}
//               onChange={(e) => setGraceMinutes(e.target.value)}
//             />
//           </div>

//           <div className="col-md-4">
//             <label className="form-label fw-semibold">Primary Weekoff</label>
//             <select
//               className="form-select"
//               value={primaryWeekoff}
//               onChange={(e) => setPrimaryWeekoff(e.target.value)}
//             >
//               {weekDays.map((day) => (
//                 <option key={day.value} value={day.value}>
//                   {day.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="col-md-4 d-flex align-items-center">
//             <div className="form-check form-switch">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 checked={enableSecondary}
//                 onChange={() => setEnableSecondary(!enableSecondary)}
//               />
//               <label className="form-check-label ms-2 fw-semibold">
//                 Secondary Weekoff
//               </label>
//             </div>
//           </div>
//         </div>

//         {enableSecondary && (
//           <div className="border rounded p-3 bg-light mt-4">
//             <div className="row g-3">
//               <div className="col-md-4">
//                 <label className="form-label fw-semibold">Secondary Day</label>
//                 <select
//                   className="form-select"
//                   value={secondaryWeekoff}
//                   onChange={(e) => setSecondaryWeekoff(e.target.value)}
//                 >
//                   {weekDays.map((day) => (
//                     <option key={day.value} value={day.value}>
//                       {day.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="col-md-8">
//                 <label className="form-label fw-semibold d-block">
//                   Repeat On
//                 </label>
//                 <div className="d-flex flex-wrap gap-3">
//                   {ordinal.map((week, index) => (
//                     <div className="form-check form-check-inline" key={index}>
//                       <input
//                         className="form-check-input"
//                         type="checkbox"
//                         value={index + 1}
//                         checked={secondaryWeekoffOccurrence.includes(index + 1)}
//                         onChange={() => handleOccurrenceChange(index + 1)}
//                       />
//                       <label className="form-check-label">{week}</label>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="mt-5">
//           <h5 className="fs-5 fw-semibold">Auto-Audit API Call</h5>
//           <span className="text-muted fs-6">
//             Automatically run audits at specific times each day.
//           </span>

//           <div className="d-flex align-items-center gap-2 mt-3">
//             <label className="custom-switch">
//               <input
//                 type="checkbox"
//                 checked={autoAuditEnabled}
//                 onChange={() => setAutoAuditEnabled(!autoAuditEnabled)}
//               />
//               <span className="custom-slider round"></span>
//             </label>
//             <label className="form-label fw-semibold">Enable Auto-Audit</label>
//           </div>

//           {autoAuditEnabled && (
//             <div className="mt-3">
//               <span className="fw-medium">Auto Audit Times</span>

//               {auditTimes.map((time, index) => (
//                 <div
//                   key={index}
//                   className="d-flex align-items-center gap-2 mt-2"
//                 >
//                   <input
//                     type="time"
//                     className="form-control w-auto"
//                     value={time}
//                     onChange={(e) => handleTimeChange(index, e.target.value)}
//                   />
//                   {index > 0 && (
//                     <X
//                       className="text-danger"
//                       style={{ cursor: "pointer" }}
//                       onClick={() => handleDeleteTime(index)}
//                     />
//                   )}
//                 </div>
//               ))}

//               <button
//                 className="btn btn-outline-primary mt-3"
//                 onClick={handleAddTime}
//               >
//                 <CirclePlus size={18} /> Add Time
//               </button>
//             </div>
//           )}
//         </div>

//         <div className="mt-4">
//           <button className="btn btn-primary" onClick={saveSettings}>
//             Save All Settings
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }


import { CirclePlus, X } from "lucide-react";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import Swal from "sweetalert2";

export default function GraceWeekoffSettings() {
  const weekDays = [
    { value: "monday", label: "Monday" },
    { value: "tuesday", label: "Tuesday" },
    { value: "wednesday", label: "Wednesday" },
    { value: "thursday", label: "Thursday" },
    { value: "friday", label: "Friday" },
    { value: "saturday", label: "Saturday" },
    { value: "sunday", label: "Sunday" },
  ];

  const ordinal = ["1st", "2nd", "3rd", "4th", "5th"];

  const [graceMinutes, setGraceMinutes] = useState("");
  const [primaryWeekoff, setPrimaryWeekoff] = useState("monday");
  const [enableSecondary, setEnableSecondary] = useState(false);
  const [secondaryWeekoff, setSecondaryWeekoff] = useState("monday");

  const [autoAuditEnabled, setAutoAuditEnabled] = useState(false);
  const [auditTimes, setAuditTimes] = useState([""]);
  const [secondaryWeekoffOccurrence, setSecondaryWeekoffOccurrence] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res = await api.get("/hrms/settings");
        const data = res.data.data;

        if (data) {
          setGraceMinutes(data.grace_minutes || "");
          setPrimaryWeekoff(data.primary_weekoff || "monday");
          setEnableSecondary(data.enable_secondary_weekoff || false);
          setSecondaryWeekoff(data.secondary_weekoff || "monday");
          setAutoAuditEnabled(data.auto_audit_enabled || false);
          setAuditTimes(data.audit_times?.length ? data.audit_times : [""]);

          //// ⭐ FIX: Load secondary weekoff occurrences
          setSecondaryWeekoffOccurrence(
            data.secondary_weekoff_occurrence?.length
              ? data.secondary_weekoff_occurrence
              : []
          );
        }
      } catch (err) {
        Swal.fire("Error", "Failed to load settings", "error");
      }
      setLoading(false);
    };

    loadSettings();
  }, []);

  const handleOccurrenceChange = (value) => {
    setSecondaryWeekoffOccurrence((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleAddTime = () => setAuditTimes([...auditTimes, ""]);

  const handleTimeChange = (i, val) => {
    const updated = [...auditTimes];
    updated[i] = val;
    setAuditTimes(updated);
  };

  const handleDeleteTime = (i) =>
    setAuditTimes(auditTimes.filter((_, index) => index !== i));

  const saveSettings = async () => {
    try {
      await api.put("/hrms/settings", {
        grace_minutes: graceMinutes,
        primary_weekoff: primaryWeekoff,
        enable_secondary_weekoff: enableSecondary,
        secondary_weekoff: enableSecondary ? secondaryWeekoff : null,

        //// ⭐ FIX: Always send array (even if empty)
        secondary_weekoff_occurrence: enableSecondary
          ? secondaryWeekoffOccurrence
          : [],

        auto_audit_enabled: autoAuditEnabled,
        audit_times: autoAuditEnabled ? auditTimes : [],
      });

      Swal.fire("Success", "Settings saved successfully", "success");
    } catch (err) {
      Swal.fire("Error", "Unable to save settings", "error");
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <h5>Loading Settings...</h5>
      </div>
    );
  }

  return (
    <>
      <div className="container mt-4">
        <div className="d-flex flex-column">
          <h5 className="fs-5 fw-semibold m-0">
            Grace Time & WeekOff Settings
          </h5>
          <span className="text-muted fs-6">
            Set the grace period for late entries, globally and week-off
            settings
          </span>
        </div>

        <div className="row align-items-end g-4 mb-4 mt-1">
          <div className="col-md-4">
            <label className="form-label fw-semibold">Grace Minutes</label>
            <input
              type="number"
              className="form-control"
              placeholder="e.g. 10"
              value={graceMinutes}
              onChange={(e) => setGraceMinutes(e.target.value)}
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Primary Weekoff</label>
            <select
              className="form-select"
              value={primaryWeekoff}
              onChange={(e) => setPrimaryWeekoff(e.target.value)}
            >
              {weekDays.map((day) => (
                <option key={day.value} value={day.value}>
                  {day.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4 d-flex align-items-center">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={enableSecondary}
                onChange={() => setEnableSecondary(!enableSecondary)}
              />
              <label className="form-check-label ms-2 fw-semibold">
                Secondary Weekoff
              </label>
            </div>
          </div>
        </div>

        {enableSecondary && (
          <div className="border rounded p-3 bg-light mt-4">
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label fw-semibold">Secondary Day</label>
                <select
                  className="form-select"
                  value={secondaryWeekoff}
                  onChange={(e) => setSecondaryWeekoff(e.target.value)}
                >
                  {weekDays.map((day) => (
                    <option key={day.value} value={day.value}>
                      {day.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-8">
                <label className="form-label fw-semibold d-block">
                  Repeat On
                </label>
                <div className="d-flex flex-wrap gap-3">
                  {ordinal.map((week, index) => (
                    <div className="form-check form-check-inline" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={index + 1}
                        checked={secondaryWeekoffOccurrence.includes(index + 1)}
                        onChange={() => handleOccurrenceChange(index + 1)}
                      />
                      <label className="form-check-label">{week}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="mt-5">
          <h5 className="fs-5 fw-semibold">Auto-Audit API Call</h5>
          <span className="text-muted fs-6">
            Automatically run audits at specific times each day.
          </span>

          <div className="d-flex align-items-center gap-2 mt-3">
            <label className="custom-switch">
              <input
                type="checkbox"
                checked={autoAuditEnabled}
                onChange={() => setAutoAuditEnabled(!autoAuditEnabled)}
              />
              <span className="custom-slider round"></span>
            </label>
            <label className="form-label fw-semibold">Enable Auto-Audit</label>
          </div>

          {autoAuditEnabled && (
            <div className="mt-3">
              <span className="fw-medium">Auto Audit Times</span>

              {auditTimes.map((time, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-2 mt-2"
                >
                  <input
                    type="time"
                    className="form-control w-auto"
                    value={time}
                    onChange={(e) => handleTimeChange(index, e.target.value)}
                  />
                  {index > 0 && (
                    <X
                      className="text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDeleteTime(index)}
                    />
                  )}
                </div>
              ))}

              <button
                className="btn btn-outline-primary mt-3"
                onClick={handleAddTime}
              >
                <CirclePlus size={18} /> Add Time
              </button>
            </div>
          )}
        </div>

        <div className="mt-4">
          <button className="btn btn-primary" onClick={saveSettings}>
            Save All Settings
          </button>
        </div>
      </div>
    </>
  );
}
